import { render, staticRenderFns } from "./ReportsPane.vue?vue&type=template&id=49b84bd6&scoped=true&"
import script from "./ReportsPane.vue?vue&type=script&lang=js&"
export * from "./ReportsPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b84bd6",
  null
  
)

export default component.exports